import './instrument'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { Result, Button } from 'antd'
import './index.css'
import App from './App.tsx'

const rootElement = document.getElementById('root')
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <Sentry.ErrorBoundary
        fallback={({ resetError }) => (
          <Result
            status="error"
            title="Something went wrong"
            subTitle="An unexpected error occurred. Our team has been notified."
            extra={[
              <Button type="primary" key="retry" onClick={resetError}>
                Try Again
              </Button>,
              <Button key="reload" onClick={() => window.location.reload()}>
                Reload Page
              </Button>,
            ]}
          />
        )}
      >
        <App />
      </Sentry.ErrorBoundary>
    </StrictMode>
  )
}
